export default "__VITE_ASSET__B35w17dZ__"